import { render } from "./pre-lander.vue?vue&type=template&id=8fde4e12"
import script from "./pre-lander.vue?vue&type=script&lang=js"
export * from "./pre-lander.vue?vue&type=script&lang=js"

import "./pre-lander.vue?vue&type=style&index=0&id=8fde4e12&lang=scss"

import exportComponent from "/__w/dryrobe.com-website/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__